function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8 60C-2 68-3 84 6 93l150 163L6 419c-9 9-8 25 2 33l24 22c10 9 25 8 34-2l185-202c7-8 7-20 0-28L66 40c-9-10-24-11-34-2L8 60z"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 512"
  }, props), _ref);
}

export default SvgChevronRight;